<template>
  <div class="row-content">
    <div class="row-title">
      <span>精英机构教练员等级（教练员总数：{{ allNumber }}）</span>
    </div>
    <div class="data-wrapper">
      <div class="echart-user-login" id="echart-user-login"></div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
var moment = require("moment");

export default {
  props: {
    propsCoachList: {
      type: Array,
      required: false,
      default: [0,0,0,0,0,0]
    }
  },
  data() {
    return {};
  },

  computed: {
    chartOptions() {
      const options = {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: false,
          textStyle: {
            color: "#61a8ff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#61a8ff",
              width: 1,
              type: "solid",
            },
          },
          // interval: 1,
          minInterval: 1,
          // minInterVal: 1,
          boundaryGap: false,
        },
        yAxis: {
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#61a8ff",
              width: 1,
              type: "solid",
            },
          },
          // interval: 1,
          // minInterVal: 1,
          minInterval: 1,
          nameTextStyle: {
            color: ["#FFFFFF"],
          },
          // data: ["职业级", "A级", "B级", "C级", "D级", "E级", "其他"],
          data: ["职业级", "A级", "B级", "C级", "D级", "E级","外籍/其他"],
        },
        color: ["#68d8fe", "#fac858", "#ee6666", "#73c0de"],
        series: [
          {
            name: "数量",
            type: "bar",
            data: this.propsCoachList,
            label: {
              show: true,
              position: "right",
              distance: 10,
              align: "center",
              verticalAlign: "middle",
            },
          },
        ],
      };
      return options;
    },
    // 查询总数
    allNumber() {
      let allCounts = 0;
      for (let key in this.propsCoachList) {
        allCounts += this.propsCoachList[key]
      }
      return allCounts
    },
  },

  mounted() {
    this.drawPie()
  },

  methods: {
    drawPie() {
      const dom = document.getElementById("echart-user-login");
      const chartObj = echarts.init(dom);
      chartObj && chartObj.setOption(this.chartOptions)
    },
  },
};
</script>


<style lang="stylus" scoped>
@import '~@/assets/css/variable1'

.row-content
  padding 1.25rem 0
  .row-title
    color #68d8fe
    font-weight 600
    font-size 16px
    margin-bottom 0.4rem
    display flex
    align-items center
  .data-wrapper
    display flex
    flex-wrap wrap
    .echart-user-login
      height 290px
      width 100%
</style>

